import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {Card, Table, Input, Button, Row, Col, Modal, notification, Tooltip, Icon} from 'antd'

import { tableColumns } from '../../dataTypes/users'
import { requestUsersList, requestUserDelete } from '../../redux/Users/actions'
import {CopyToClipboard} from "react-copy-to-clipboard";

class Users extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            userSearch: '',
            showModal: false,
            userShow: {},
            modalShowAccessToken: false
        }
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        const { requestUsersList } = this.props

        requestUsersList()
    }

    onChangePage = page => {
        const { requestUsersList } = this.props

        requestUsersList(page, this.state.userSearch)
    }

    searchUser = () => {
        const { requestUsersList } = this.props

        requestUsersList(1, this.state.userSearch)
    }

    handleChange = event => {
        this.setState({ userSearch: event.target.value })
    }

    handleDelete = userId => {
        const { requestUserDelete } = this.props

        requestUserDelete({ userId, filter: this.state.userSearch })
    }

    showUserModal = userId => {
        const { usersList } = this.props
        const userFind = usersList.find(user => user.user_id === userId)
        this.setState({
            userShow: userFind,
            showModal: true
        })
    }

    renderIconEyeModal = () => {
        if (this.state.modalShowAccessToken) {
            return (
                <Icon type="eye" style={{marginRight: 6}} onClick={() => this.setState({modalShowAccessToken: false})}/>
            )
        }else {
            return (
                <Icon type="eye-invisible" style={{marginRight: 6}} onClick={() => this.setState({modalShowAccessToken: true})}/>
            )
        }
    }
    render() {
        const {
            usersList,
            pagination: { page_size, page_number, total_entries }
        } = this.props

        return (
            <Card title="Users Table">
                <div>
                    <Row type="flex">
                        <Col lg={8} md={12} xs={16}>
                            <Input
                                placeholder="User ID or username"
                                onChange={this.handleChange}
                                value={this.state.userSearch}
                                onPressEnter={this.searchUser}
                            />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                            <Button type="primary" onClick={this.searchUser}>
                                Search
                            </Button>
                        </Col>
                    </Row>
                </div>

                <Table
                    rowKey={record => record.user_id}
                    className="gx-table-responsive"
                    columns={tableColumns({
                        handleDelete: this.handleDelete,
                        showUserModal: this.showUserModal
                    })}
                    dataSource={usersList}
                    bordered
                    pagination={{
                        onChange: this.onChangePage,
                        pageSize: page_size,
                        current: page_number,
                        total: total_entries
                    }}
                />

                <Modal
                    title="User Info"
                    visible={this.state.showModal}
                    onOk={()=> {this.setState({showModal: false})}}
                    onCancel={()=> {this.setState({showModal: false})}}
                    width={700}
                    footer={null}
                >
                    <Input
                        value={this.state.userShow.username}
                        addonBefore="Username"
                        style={{marginBottom: 10}}
                    />
                    <Input
                        value={this.state.userShow.user_id}
                        addonBefore="User Id"
                        style={{marginBottom: 10}}
                    />
                    <Input
                        type={this.state.modalShowAccessToken ? "text": "password"}
                        value={this.state.userShow.access_token}
                        suffix={
                                <div>
                                {
                                this.renderIconEyeModal()
                                }
                                <CopyToClipboard text={this.state.userShow.access_token}  onCopy={() => notification['success']({message: 'Success copy'})}>
                                <Tooltip placement="bottom" title={"Copy the access token"}>
                                <Icon type="copy"/>
                                </Tooltip>
                                </CopyToClipboard>
                                </div>
                            }
                        addonBefore="Access Token"
                    />

                </Modal>
            </Card>
        )
    }
}

const mapStateToProps = state => ({
    usersList: state.users.list,
    pagination: state.users.pagination
})

const mapActionsToProps = dispatch => ({
    requestUsersList: bindActionCreators(requestUsersList, dispatch),
    requestUserDelete: bindActionCreators(requestUserDelete, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(Users)
